import { useEffect, useState } from "react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { Field, PageTitle, btnPrimary, card, inputCls } from "@/components/admin/ui";

export default function AdminAccount() {
  const { user, refreshUser } = useAuth();
  const [form, setForm] = useState({ name: "", email: "", current_password: "" });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (user) setForm({ name: user.name || "", email: user.email || "", current_password: "" });
  }, [user]);

  const emailChanged = user && form.email.trim().toLowerCase() !== (user.email || "").toLowerCase();
  const dirty = user && (emailChanged || form.name.trim() !== (user.name || ""));

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.patch("/auth/me", form);
      localStorage.setItem("df_token", data.token);
      await refreshUser();
      setForm((f) => ({ ...f, current_password: "" }));
      toast.success("Account updated");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Could not update your account");
    } finally {
      setSaving(false);
    }
  };

  if (!user) return null;

  return (
    <div data-testid="admin-account-page">
      <PageTitle title="Account" />
      <div className={`${card} max-w-[520px] p-5 space-y-4`}>
        <Field label="Name">
          <input
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            placeholder="Your name"
            className={inputCls}
            data-testid="account-name-input"
          />
        </Field>
        <Field label="Email" hint="This is the email you log in with.">
          <input
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            placeholder="you@example.com"
            className={inputCls}
            data-testid="account-email-input"
          />
        </Field>
        {emailChanged && (
          <Field label="Current password" hint="Required to change your login email.">
            <input
              type="password"
              value={form.current_password}
              onChange={(e) => setForm({ ...form, current_password: e.target.value })}
              placeholder="Current password"
              className={inputCls}
              data-testid="account-password-input"
            />
          </Field>
        )}
        <button
          type="button"
          className={btnPrimary}
          disabled={!dirty || saving || (emailChanged && !form.current_password)}
          onClick={save}
          data-testid="account-save-button"
        >
          {saving ? "Saving…" : "Save changes"}
        </button>
      </div>
    </div>
  );
}
